var map = {
	"./facebook.png": 70628,
	"./instagram.png": 44853,
	"./line.png": 77639,
	"./linkedin.png": 82918,
	"./pinterest.png": 29297,
	"./skype.png": 93481,
	"./telegram.png": 22809,
	"./twitter.png": 40043,
	"./wechat.png": 15351,
	"./whatsapp.png": 21922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57260;